import { Col } from "react-bootstrap";
import Image from "next/image";
import Link from "next/link";
import myImage from '/src/images/verified.png';


const FooterOurRecognitions = ({ recognitions }) => {
    return (
        <Col sm={12} md={12} xl={12} lg={12}>
            <div className="footer-col our-recognitions">
                <div className="footer-col-title">
                    <p>Our Recognitions</p>
                </div>
                <span style={{ margin: "10px 0 10px 0" }}>

                    <Link
                        href="https://www.designrush.com/"
                    // className="cursor-pointer"
                    >
                        <Image
                            src={myImage}
                            alt="badge"
                            width={150}
                            height={150}
                            sizes="100vw"
                        />
                    </Link>

                </span>
                {/* <ul>
                    {recognitions?.map(
                        (ele) => {
                            const recognitionsImage = ele?.badge?.url;
                            return (
                                <li key={`Recognitions-${ele.id}`}>
                                    <Link
                                        href={ele?.link?.href || "#"}
                                    // className="cursor-pointer"
                                    >
                                        <NextImage
                                            src={`${baseUrl}${recognitionsImage}`}
                                            alt={`${ele?.badge.alternativeText}`}
                                            rel="nofollow"
                                            width={0}
                                            height={0}
                                            sizes="100vw"
                                        />
                                    </Link>
                                </li>
                            );
                        }
                    )}
                </ul> */}
            </div>
        </Col>
    );
};

export default FooterOurRecognitions;
